import { KeycloakOptions, KeycloakService } from 'keycloak-angular';
import { environment } from '../../environments/environment';

export function initializeKeycloak(
    keycloak: KeycloakService
) {

    return () => {

        const options =
            getKeycloakOptions();

        return keycloak.init({

            config: options.config,

            initOptions: options.initOptions

        });

    };

}

export function getKeycloakOptions(): KeycloakOptions {


    const params = new URLSearchParams(
        globalThis.location.search
    );


    const windowToken = (globalThis.window as any).mobileToken;
    const windowRefreshToken = (globalThis.window as any).mobileRefreshToken;
    const queryToken = params.get('token');
    const queryRefreshToken = params.get('refreshToken');

    const storedToken = (globalThis.window as any).flutter_token_value ||
        sessionStorage.getItem('flutter_token') || sessionStorage.getItem('auth_token') ||
        localStorage.getItem('flutter_token') || localStorage.getItem('auth_token') ||
        sessionStorage.getItem('kc_token');

    const storedRefreshToken = sessionStorage.getItem('kc_refresh_token');
    const token = windowToken ?? queryToken ?? storedToken;
    const refreshToken = windowRefreshToken ?? queryRefreshToken ?? storedRefreshToken;

    const initOptions: any = {

        checkLoginIframe: false,
        pkceMethod: 'S256',
        useNonce: true
    };

    if (token) {
        initOptions.token = token;
        if (refreshToken) {
            initOptions.refreshToken = refreshToken;
        }
    } else {
        initOptions.onLoad = 'login-required';
    }

    return {
        config: {
            url: environment.URL_KEYCLOAK,
            realm: environment.REALM,
            clientId: environment.CLIENT_ID
        },
        initOptions
    };
}
